import {ErrorHandler, NgModule} from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {MatSidenavModule} from "@angular/material/sidenav";
import {MatToolbarModule} from "@angular/material/toolbar";
import {MatButtonModule} from "@angular/material/button";
import {MatListModule} from "@angular/material/list";
import {MatIconModule} from "@angular/material/icon";
import {MatSlideToggleModule} from "@angular/material/slide-toggle";
import {MatMenuModule} from "@angular/material/menu";
import {MatExpansionModule} from "@angular/material/expansion";
import { LoginComponent } from './modules/login/login.component';
import { AppRoutingModule } from './app-routing.module';
import { ItemsOverviewComponent } from './modules/items-overview/items-overview.component';
import {FlexLayoutModule} from "@angular/flex-layout";
import {MatBadgeModule} from "@angular/material/badge";
import { TableNumberComponent } from './modules/table-number/table-number.component';
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {MatInputModule} from "@angular/material/input";
import {MatButtonToggleModule} from "@angular/material/button-toggle";
import { PrintReceiptModalComponent } from './shared/components/print-receipt-modal/print-receipt-modal.component';
import {MatDialogModule} from "@angular/material/dialog";
import { CheckoutComponent } from './modules/checkout/./checkout.component';
import {HTTP_INTERCEPTORS, HttpClientModule} from "@angular/common/http";
import { CreateWaiterComponent } from './modules/create-waiter/create-waiter.component';
import { ReceivedOrdersOverviewComponent } from './modules/received-orders-overview/received-orders-overview.component';
import { ReceiptsOverviewComponent } from './modules/receipts-overview/receipts-overview.component';
import { IncomingOrdersOverviewComponent } from './modules/incoming-orders-overview/incoming-orders-overview.component';
import { ManageItemsComponent } from './modules/manage-items/manage-items.component';
import { AdministrationComponent } from './modules/administration/administration.component';
import { WaiterCheckinCheckoutComponent } from './modules/waiter-checkin-checkout/waiter-checkin-checkout.component';
import {MatSnackBar, MatSnackBarModule} from "@angular/material/snack-bar";
import { WaiterOverviewComponent } from './modules/waiter-overview/waiter-overview.component';
import {MatTableModule} from "@angular/material/table";
import { ReceivedOrdersDetailsPopupComponent } from './modules/received-orders-overview/received-orders-details-popup/received-orders-details-popup.component';
import { YesNoPipe } from './yes-no.pipe';
import {MatRadioModule} from "@angular/material/radio";
import {MatSelectModule} from "@angular/material/select";
import { ItemDetailsPopupComponent } from './modules/manage-items/item-details-popup/item-details-popup.component';
import {MatCheckboxModule} from "@angular/material/checkbox";
import {JwtInterceptor} from "./core/http/jwt.interceptor";
import {CategoryOverviewComponent} from "./modules/category-overview/category-overview.component";
import {
  CategoryDetailsPopupComponent
} from "./modules/category-overview/category-details-popup/category-details-popup.component";
import {YesNoModalComponent} from "./shared/components/yes-no-modal/yes-no-modal.component";
import {PrinterOverviewComponent} from "./modules/printer-overview/printer-overview.component";
import {
  PrinterDetailsPopupComponent
} from "./modules/printer-overview/printer-details-popup/printer-details-popup.component";
import {TenantOverviewComponent} from "./modules/tenant-overview/tenant-overview.component";
import {
  QueueCategoryAssignmentComponent
} from "./modules/queue-category-assignment/queue-category-assignment.component";
import {
  WaiterOverviewDetailsComponent
} from "./modules/waiter-overview/waiter-overview-details/waiter-overview-details.component";
import {SimplePopupComponent} from "./shared/components/simple-popup/simple-popup.component";
import {GlobalErrorHandler} from "./global-error-handler";
import {ShowErrorsComponent} from "./modules/show-errors/show-errors.component";

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    ItemsOverviewComponent,
    TableNumberComponent,
    PrintReceiptModalComponent,
    CheckoutComponent,
    CreateWaiterComponent,
    ReceivedOrdersOverviewComponent,
    ReceiptsOverviewComponent,
    IncomingOrdersOverviewComponent,
    ManageItemsComponent,
    AdministrationComponent,
    WaiterCheckinCheckoutComponent,
    WaiterOverviewComponent,
    ReceivedOrdersDetailsPopupComponent,
    CategoryOverviewComponent,
    YesNoPipe,
    ItemDetailsPopupComponent,
    CategoryDetailsPopupComponent,
    YesNoModalComponent,
    PrinterOverviewComponent,
    PrinterDetailsPopupComponent,
    TenantOverviewComponent,
    QueueCategoryAssignmentComponent,
    WaiterOverviewDetailsComponent,
    SimplePopupComponent,
    ShowErrorsComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    MatSidenavModule,
    MatToolbarModule,
    MatButtonModule,
    MatListModule,
    MatIconModule,
    MatSlideToggleModule,
    MatMenuModule,
    MatExpansionModule,
    AppRoutingModule,
    FlexLayoutModule,
    MatBadgeModule,
    FormsModule,
    MatInputModule,
    MatButtonToggleModule,
    MatDialogModule,
    HttpClientModule,
    ReactiveFormsModule,
    MatSnackBarModule,
    MatTableModule,
    MatRadioModule,
    MatSelectModule,
    MatCheckboxModule
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    { provide: ErrorHandler, useClass: GlobalErrorHandler }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
